export default "__VITE_ASSET__95caa90b__"